import dayjs from "dayjs";
import "dayjs/locale/en";
export var separateMinutesSeconds = function (_seconds) {
    var minutes = Math.floor(_seconds / 60);
    var seconds = _seconds % 60;
    return { minutes: minutes, seconds: seconds };
};
export var fixedTime = function (time, decimalPoint) {
    if (decimalPoint === void 0) { decimalPoint = 1; }
    return Math.round(time * Math.pow(10, decimalPoint)) / Math.pow(10, decimalPoint);
};
export var zeroPadding = function (time) {
    return "".concat(time).padStart(2, "0");
};
// see: https://www.figma.com/file/SXE1Qfx8OAAzvXEK8kSxO0/00_Component_Basic?node-id=6295-4384
export var dateFormat = "YYYY年M月D日";
export var dateFormatEn = "MMMM D, YYYY";
export var dateFormatKo = "YYYY년M월D일";
export var dateTimeFormat = "".concat(dateFormat, " HH:mm");
export var dateTimeFormatEn = "".concat(dateFormatEn, " HH:mm");
export var dateTimeFormatKo = "".concat(dateFormatKo, " HH:mm");
export var monthFormat = "YYYY年M月";
export var monthFormatEn = "MMMM YYYY";
export var monthFormatKo = "YYYY년M월";
export var formatDate = function (date, locale) {
    if (locale === void 0) { locale = "ja"; }
    if (locale === "en") {
        return dayjs(date).locale("en").format(dateFormatEn);
    }
    if (locale === "ko") {
        return dayjs(date).format(dateFormatKo);
    }
    return dayjs(date).format(dateFormat);
};
export var formatDateTime = function (date, locale) {
    if (locale === void 0) { locale = "ja"; }
    if (locale === "en") {
        return dayjs(date).locale("en").format(dateTimeFormatEn);
    }
    if (locale === "ko") {
        return dayjs(date).format(dateTimeFormatKo);
    }
    return dayjs(date).format(dateTimeFormat);
};
export var formatMonth = function (date, locale) {
    if (locale === void 0) { locale = "ja"; }
    if (locale === "en") {
        return dayjs(date).locale("en").format(monthFormatEn);
    }
    if (locale === "ko") {
        return dayjs(date).format(monthFormatKo);
    }
    return dayjs(date).format(monthFormat);
};
//# sourceMappingURL=formatUtils.js.map